import React from 'react';

export function EmailIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M44 12c0-2.2-1.8-4-4-4H8c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V12zm-4 0l-15.47 9.669a1 1 0 01-1.06 0L8 12h32zm0 23a1 1 0 01-1 1H9a1 1 0 01-1-1V16l15.47 9.669a1 1 0 001.06 0L40 16v19z" />
    </svg>
  );
}
